export default __webpack_public_path__ + "static/media/139.b6bec8c8.jpg";